export function isBrowser(): boolean {
  // Detects the browser at runtime; there is no value to parse at a boundary here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

const getEnvironmentFromUrl = () => {
  const hostname = window.location.hostname;

  switch (hostname) {
    case 'chime.com':
    case 'www.chime.com':
    case 'chime-com.chime.com':
    case 'enterprise.chime.com':
    case 'careers.chime.com':
      return 'production';
    case 'localhost':
      return 'local';
    default:
      // Extract environment from subdomain (e.g., chime-com-dev1.chime.com -> dev1)
      const match = hostname.match(/^(chime-com|enterprise|careers)-([^.]+)\.chime\.com$/);
      return match ? match[2] : 'development';
  }
};

export const appEnvironment =
  // Detects the browser at runtime; there is no value to parse at a boundary here.
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  typeof window === 'undefined'
    ? process.env.ENV || process.env.NODE_ENV // Server-side
    : getEnvironmentFromUrl(); // Client-side

export const isLocalEnvironment = () => appEnvironment === 'local';
export const isQAEnvironment = () => appEnvironment === 'qa'; // used only for data dog RUM collection in QA
export const isProdEnvironment = () => appEnvironment === 'production';
export const isE2ETesting = () => {
  // NEXT_PUBLIC_ env vars are available on both server and client
  return process.env.NEXT_PUBLIC_E2E_TESTING === 'true';
};
